import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wellInfoWrap: FelaCSS;
  infoText: FelaCSS;
  moreWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wellInfoWrap: {
    ':not(:last-of-type)': {
      marginBottom: spacing[2],
    },
  },

  infoText: {
    display: 'block',
    marginTop: spacing[2],
    fontDefault: 14,
    lineHeight: '20px',
    color: colors.space60,
    whiteSpace: 'pre-line',
  },

  moreWrap: {
    display: 'inline',
    marginLeft: '5px',
    padding: spacing[2],
  },
});

export default styles;
